<template>
  <v-layout row>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>{{ $t('StationEditStationCategory.editTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-select dense label="Select a station category" v-model="stationCategory" :items="stationCategoryNames" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="success" @click.native="submit()" :loading="loading">
            <v-icon class="mr-1">done</v-icon>
            {{ $t('Button.Save') }}
          </v-btn>
          <v-btn color="secondary" outline @click="close()">{{ $t('Button.Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const authenticate = createNamespacedHelpers('authenticate')
  const stations = createNamespacedHelpers('stations')
  const app = createNamespacedHelpers('app')
  const stationManagement = createNamespacedHelpers('stationmanagement')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  export default {
    data() {
      return {
        dialog: false,
        stationCategory: null,
        loading: false,
      }
    },
    computed: {
      ...stations.mapGetters([
        'stationCategories',
      ]),
      ...authenticate.mapGetters(['currentTenant']),
      ...monitoringFeatures.mapGetters([
        'currentFeatureDataSourceIndexByType',
      ]),
      ...dataSources.mapGetters([
        'dataSourceIndex',
      ]),
      stationCategoryNames() {
        return this.stationCategories.map(sc => sc.Name)
      },
      featureDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.discreteEnvirodata]
      },
      discreteStation() {
        return this.dataSourceIndex[SOURCE_TYPES.discreteEnvirodata][this.featureDataSource.SourceId]
      },
      currentStationId() {
        return this.discreteStation.Id
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...stationManagement.mapActions(['editStationCategory']),
      ...dataSources.mapActions(['fetchDataSource']),
      show() {
        this.dialog = true
        this.stationCategory = JSON.parse(JSON.stringify(this.discreteStation.LocationType))
      },
      async submit() {
        this.loading = true
        try {
          const payload = {
            UserGroupId: this.currentTenant.id,
            StationId: this.currentStationId,
            StationCategory: this.stationCategory,
          }

          await this.editStationCategory(payload)
          await this.fetchDataSource({
            sourceType: SOURCE_TYPES.discreteEnvirodata,
            sourceId: this.currentStationId,
          })

          this.close()

        } catch (error) {
          this.setSnackbar({
            text: error,
            color: 'success',
            icon: 'done',
          })
        }

        this.loading = false
      },
      close() {
        this.dialog = false
      },
    },
  }
</script>